export type ViewMode = 'input' | 'preview';
export type AssetType = 'image' | 'video';

export interface IGenerationPrompt {
    header: string;
    text: string;
}

export interface IGenerateAssetFromReference {
    assetId: string;
    enrichWithText: string;
    model: IMAGE_GENERATION_MODELS_ENUM;
    aspectRatio: ASPECT_RATIO_ENUM;
    toUseLogo: boolean;
}

export interface IGenerateAssetFromText {
    text: string;
    model: IMAGE_GENERATION_MODELS_ENUM;
    aspectRatio: ASPECT_RATIO_ENUM;
    toUseLogo: boolean;
}
export interface IImageGenerateModel {
    name: string;
    value: IMAGE_GENERATION_MODELS_ENUM;
}

export interface IVideoGenerateModel {
    name: string;
    value: VIDEO_GENERATION_MODELS_ENUM;
}

export interface IGenerateImageSettingsChange {
    model: IImageGenerateModel;
    aspectRatio: ASPECT_RATIO_ENUM;
}
export interface IGenerateVideoSettingsChange {
    model: IVideoGenerateModel;
    aspectRatio: ASPECT_RATIO_ENUM;
}
export enum ASPECT_RATIO_ENUM {
    _1_1 = '1:1',
    _16_9 = '16:9',
    _9_16 = '9:16',
    _4_3 = '4:3',
    _3_4 = '3:4',
}
export enum IMAGE_GENERATION_MODELS_ENUM {
    IMAGE_STABILITY = 'IMAGE_STABILITY',
    IMAGE_NANOBANANA = 'IMAGE_NANOBANANA',
    IMAGE_NANOBANANA_PRO = 'IMAGE_NANOBANANA_PRO',
    IMAGE_IMAGEN4_GENERATE = 'imagen-4.0-generate-001',
    IMAGE_IMAGEN4_ULTRA = 'imagen-4.0-ultra-generate-001',
    IMAGE_IMAGEN4_FAST = 'imagen-4.0-fast-generate-001',
}

export type ImageModelPreset = 'all' | 'logo-only';

export const IMAGE_MODELS_BY_PRESET: Record<ImageModelPreset, IImageGenerateModel[]> = {
    all: [
        { name: 'Imagen 4.0', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_IMAGEN4_GENERATE },
        { name: 'Imagen 4.0 Ultra', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_IMAGEN4_ULTRA },
        { name: 'Imagen 4.0 Fast', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_IMAGEN4_FAST },
        { name: 'Nano Banana', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_NANOBANANA },
        { name: 'Nano Banana Pro', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_NANOBANANA_PRO },
        { name: 'Stability', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_STABILITY },
    ],

    'logo-only': [{ name: 'Nano Banana Pro', value: IMAGE_GENERATION_MODELS_ENUM.IMAGE_NANOBANANA_PRO }],
};

export enum VIDEO_GENERATION_MODELS_ENUM {
    VIDEO_VEO3 = 'VIDEO_VEO3',
    VIDEO_SORA2 = 'VIDEO_SORA2',
}
